const $ = require('jquery');
require('slick-carousel-latest');

$( function () {
	$('[id^="tab-slider-"] .slick-slide-wrapper').each(
		(_index, sliderWrapper) => {
			if (sliderWrapper.onclick == null) {
				sliderWrapper.onclick = (event) => {
					let slide = event.currentTarget;
					let parentSlider = $(slide).parents('[data-slick]').first();

					if (parentSlider) {
						let isNav =
							parentSlider.attr('id').split('-').pop() == 'nav';
						let sliderToControl = isNav
							? parentSlider.next()
							: parentSlider.prev();
						if (sliderToControl) {
							let slickObj = sliderToControl.slick('getSlick');
							if (!slickObj.unslicked) {
								slickObj.slickGoTo(slide.dataset.slickIndex);
							}
						}
					}
				};
			}
		}
	);
	function parseCustomHtmlData() {
		$('[id^="tab-slider-"] .slick-initialized').each(
			(sliderBlockIndex, sliderBlock) => {
				$(sliderBlock)
					.find(
						'.slick-slide:not(.slick-cloned) .slick-slide-wrapper'
					)
					.each((_index, sliderWrapper) => {
						let customHtml = $(sliderWrapper).data('customhtml')
							? JSON.parse($(sliderWrapper).data('customhtml'))
							: '';
						if (customHtml) {
							assignCustomHtmlTosliderDot(
								_index,
								customHtml,
								sliderWrapper
							);
						}
					});
			}
		);
	}
	function assignCustomHtmlTosliderDot(
		slideIndex,
		customHtml,
		sliderWrapper
	) {
		$(sliderWrapper)
			.closest('.slick-dotted')
			.find('.slick-dots')
			.addClass('slick-custom-dots')
			.find('li:eq(' + slideIndex + ') button')
			.addClass('slick-custom-dot')
			.html(customHtml);
	}
	// Calls when the window is fully loaded
	$(window).on( 'load', ( event ) => {
		parseCustomHtmlData();
	});
	// Calls on window resize
	$(window).on('resize', debounce(parseCustomHtmlData, 500));
});
